const getOr = require('lodash/fp/getOr');
const SUB_ASSET_SHORT_GROUP_NAMES = require('../../constants');

function parsePositionNewAsset(position) {
  const p = path => getOr(null, path, position);

  return {
    secID: p('psPosId') || null,
    name: p('psDesc') || p('assetDescription') || null,
    title: p('psAstName') || null,
    number: p('psSecNmb') || p('psActNo') || null,
    description: p('psDesc') || p('assetDescription') || null,
    id: `${p('psPosId')}-${p('psCcy')}-${p('psRicCode')}`
      .replace(/\./g, '-'),
    isin: p('psIsin') || null,
    rating: p('shownRating') != null && p('shownRatingAgency') != null ? p('shownRating') + ' / ' + p('shownRatingAgency') : null,
    assetClass: p('psAstCls') || null,
    assetGroupId: p('psAstGrpCd') || null,
    assetShortDesc: SUB_ASSET_SHORT_GROUP_NAMES[p('psAstGrpCd')] || null,
    currency: p('psCcy') || null,
    availableBalance: p('psAvaBal') || null,
    accruedInterest: p('psAccIntRefCcy') || null,
    balance: p('psMktValuePosCcy') || null,
    quantity: parseQuantity(p, SUB_ASSET_SHORT_GROUP_NAMES[p('psAstGrpCd')]),
    depositeAmount: p('psDepAmt') || null,
    marketValue: p('psMktValueRefCcy') || p('psMktValRefCcy') || null,
    unrealisedGL: p('psUnrGinLosRefCcy') || null,
    unrealisedGLPercent: p('psUnrGinLosPerc') || null,
    averagePurchasePrice: p('psPurPrc') || null,
    lastPrice: p('psMktPrc') || null,
    priceDate: p('psMktPrcDt') || null,
    dayChange: p(['ratesHistory', 'psDayChg']) || null,
    dayChangePercentage: p(['ratesHistory', 'pSDayChgPct']) || null,
    unrealisedGLPositionCurrency: p('psUnrGinLosPosCcy') || null,
    proportion: p('psActPct') || null,
    ricCode: p('psRicCode') || null,
    asOfDate: p('asOfDate') || null,
    maturityDate: p('psMtrDte') || p('maturityDate') || null,
    subAssetsDesc: p('subAssetsDesc') || null,
    restrictedSecurity: true,
    restricted: p('restrictedInd') || null,
    enabled: p('enabledInd') || null,
    tradable: p('tradableInd') || null,
	  nextRolloverDate: p('psNextCpnDate') || null,
	  interestDueOnNextRolloverDate: p('psAcdIntTrdPosCcy') || null,
  };

}

function parseQuantity(p, assetShortDesc) {
  if (assetShortDesc == 'cash') {
    if (p('psAvaBal') === undefined || p('psAvaBal') === null) {
      return null;
    } else {
      return p('psAvaBal');
    }
  } else if (assetShortDesc == 'mmDeposites') {
    if (p('psDepAmt') === undefined || p('psDepAmt') === null) {
      return null;
    } else {
      return p('psDepAmt');
    }
  } else {
    if ((p('psQty') === undefined || p('psQty') === null) && (p('psNotionalAmt') === undefined || p('psNotionalAmt') === null)) {
      return null;
    } else {
      return (p('psQty') || p('psNotionalAmt'));
    }
  }
}

function parseValueMovement(vm) {
  var valueArray = [];
  if (vm == null) {
    valueArray = [];
  }
  else {
    if (vm.length > 1) {
      for (let i = 0; i < vm.length; i++) {
        let newVm = vm[i];
        valueArray.push({
          'date': newVm.psMktPrcDte || newVm.asOfDate || null,
          'formattedDate': newVm.psMktPrcDte || newVm.asOfDate || null,
          'price': newVm.psMktPrc || newVm.psAvaBal || null
        });
      }
    }
  }
  return JSON.stringify(valueArray);
}

module.exports = parsePositionNewAsset;
